'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
	(function (TextParallax, $) {
		var $dom = {};

		var cacheDom = function cacheDom() {
			$dom.TextParallax = $('[data-text-parallax]');
			$dom.TextParallaxFlipped = $('[data-text-parallax-flipped]');
		};

		var TextParallaxInit = function TextParallaxInit() {
			var offset = 350;
			var textParallax = function textParallax(current) {
				var textOffset = current.parent().offset().top - offset;

				if ($(window).scrollTop() > textOffset && $(window).scrollTop() < textOffset + $(window).height()) {
					var topPosition = ($(window).scrollTop() - textOffset) / 4;
					if ($(window).width() < 480) {
						topPosition = ($(window).scrollTop() - textOffset) / 6.5;
					}
					if (topPosition < 0) {
						topPosition = 0;
					}
					current.css('margin-top', topPosition);
				}
			};
			$dom.TextParallax.each(function () {
				textParallax($(this));
			});
			$(window).on('scroll', function () {
				$dom.TextParallax.each(function () {
					textParallax($(this));
				});
			});
		};

		var TextParallaxFlippedInit = function TextParallaxFlippedInit() {
			var offset = 350;
			var textFlippedParallax = function textFlippedParallax(current) {
				var textOffset = current.parent().offset().top - offset;

				if ($(window).scrollTop() > textOffset && $(window).scrollTop() < textOffset + $(window).height()) {
					var topPosition = ($(window).scrollTop() - textOffset) / 4;
					if ($(window).width() < 480) {
						topPosition = ($(window).scrollTop() - textOffset) / 6.5;
					}
					if (topPosition < 0) {
						topPosition = 0;
					}
					current.css('margin-bottom', topPosition * -1);
				}
			};
			$dom.TextParallaxFlipped.each(function () {
				textFlippedParallax($(this));
			});
			$(window).on('scroll', function () {
				$dom.TextParallaxFlipped.each(function () {
					textFlippedParallax($(this));
				});
			});
		};

		TextParallax.init = function () {
			cacheDom();
			TextParallaxInit();
			TextParallaxFlippedInit();
		};
	})(window.TextParallax = window.TextParallax || {}, _jquery2.default, undefined);
};